import Wedding from "../../../entities/Wedding/ui/Wedding";

const WeddingPage = () => {
    return ( 
        <main>
            <Wedding/>
        </main>
     );
}
 
export default WeddingPage;